import { FC } from "react";

import {
  CrudEditContextWrapper,
  RideEditFormTagWrapper,
  RidesDragContextWrapper,
} from "@ryde/controls";
import {
  IInjectedDrawerProps,
  IRideDto,
  IRideEditFormDrawerProps,
  RideCrudModeKey,
} from "@ryde/shared";

import { RideEditContentDrawer } from "./components";

export const RideEditFormDrawer: FC<
  IRideEditFormDrawerProps & IInjectedDrawerProps
> = ({
  resolveFn,
  onCloseDrawer,
  onCloseCustomAction,
  idCopyFrom,
  id,
  drawerNumber,
  duplicateReverseStations,
}) => {
  return (
    <CrudEditContextWrapper<IRideDto>
      entity={RideCrudModeKey.uiUnit}
      mode={RideCrudModeKey.formMode}
      id={id}
      idCopyFrom={idCopyFrom}
      duplicateReverseStations={duplicateReverseStations}
    >
      <RideEditFormTagWrapper>
        <RidesDragContextWrapper>
          <RideEditContentDrawer
            resolveFn={resolveFn}
            onCloseDrawer={onCloseDrawer}
            onCloseCustomAction={onCloseCustomAction}
            drawerNumber={drawerNumber}
            id={id}
            idCopyFrom={idCopyFrom}
          />
        </RidesDragContextWrapper>
      </RideEditFormTagWrapper>
    </CrudEditContextWrapper>
  );
};
